// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.main-bg {

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}

:is(.dark .main-bg) {

    --tw-bg-opacity: 1;

    background-color: rgb(10 12 23 / var(--tw-bg-opacity))
}

.secondary-bg {

    --tw-bg-opacity: 1;

    background-color: rgb(250 250 250 / var(--tw-bg-opacity))
}

:is(.dark .secondary-bg) {

    --tw-bg-opacity: 1;

    background-color: rgb(15 19 36 / var(--tw-bg-opacity))
}

.third-bg {

    --tw-bg-opacity: 1;

    background-color: rgb(243 243 243 / var(--tw-bg-opacity))
}

:is(.dark .third-bg) {

    --tw-bg-opacity: 1;

    background-color: rgb(26 32 53 / var(--tw-bg-opacity))
}

.fourth-bg {

    --tw-bg-opacity: 1;

    background-color: rgb(253 253 253 / var(--tw-bg-opacity))
}

:is(.dark .fourth-bg) {

    --tw-bg-opacity: 1;

    background-color: rgb(36 43 73 / var(--tw-bg-opacity))
}

.main-border {

    border-width: 1px;

    --tw-border-opacity: 1;

    border-color: rgb(209 213 219 / var(--tw-border-opacity))
}

:is(.dark .main-border) {

    --tw-border-opacity: 1;

    border-color: rgb(51 65 85 / var(--tw-border-opacity))
}

.normal-border {

    border-width: 1px;

    --tw-border-opacity: 1;

    border-color: rgb(66 66 66 / var(--tw-border-opacity))
}

:is(.dark .normal-border) {

    --tw-border-opacity: 1;

    border-color: rgb(217 217 217 / var(--tw-border-opacity))
}

.flex-center {

    display: flex;

    align-items: center;

    justify-content: center
}

.flex-start {

    display: flex;

    align-items: center;

    justify-content: flex-start
}

.menu-hover:hover {

    --tw-bg-opacity: 1;

    background-color: rgb(229 231 235 / var(--tw-bg-opacity))
}

:is(.dark .menu-hover:hover) {

    --tw-bg-opacity: 1;

    background-color: rgb(30 41 59 / var(--tw-bg-opacity))
}

.text-secondary {

    --tw-text-opacity: 1;

    color: rgb(66 66 66 / var(--tw-text-opacity))
}

:is(.dark .text-secondary) {

    --tw-text-opacity: 1;

    color: rgb(217 217 217 / var(--tw-text-opacity))
}

.text-third {

    --tw-text-opacity: 1;

    color: rgb(75 85 99 / var(--tw-text-opacity))
}

:is(.dark .text-third) {

    --tw-text-opacity: 1;

    color: rgb(148 163 184 / var(--tw-text-opacity))
}

.w-line {

    height: 1px;

    width: 100%;

    --tw-bg-opacity: 1;

    background-color: rgb(15 19 36 / var(--tw-bg-opacity));

    opacity: 0.2
}

:is(.dark .w-line) {

    --tw-bg-opacity: 1;

    background-color: rgb(250 250 250 / var(--tw-bg-opacity))
}

.mini-w-line {

    height: 1px;

    width: 24px;

    --tw-bg-opacity: 1;

    background-color: rgb(15 19 36 / var(--tw-bg-opacity));

    opacity: 0.2
}

:is(.dark .mini-w-line) {

    --tw-bg-opacity: 1;

    background-color: rgb(250 250 250 / var(--tw-bg-opacity))
}

.page-content {

    margin-left: auto;

    margin-right: auto;

    margin-top: 1.5rem;

    max-width: 1367px;

    padding-left: 1rem;

    padding-right: 1rem;

    padding-bottom: 2.5rem
}

@media (min-width: 1024px) {

    .page-content {

        margin-top: 5rem;

        padding-left: 2rem;

        padding-right: 2rem
    }
}

`, "",{"version":3,"sources":["webpack://./src/styles/css/global.css"],"names":[],"mappings":";;AAGI;;IAAA,kBAA2C;;IAA3C;AAA2C;;AAA3C;;IAAA,kBAA2C;;IAA3C;AAA2C;;AAI3C;;IAAA,kBAA+C;;IAA/C;AAA+C;;AAA/C;;IAAA,kBAA+C;;IAA/C;AAA+C;;AAI/C;;IAAA,kBAA+C;;IAA/C;AAA+C;;AAA/C;;IAAA,kBAA+C;;IAA/C;AAA+C;;AAI/C;;IAAA,kBAA+C;;IAA/C;AAA+C;;AAA/C;;IAAA,kBAA+C;;IAA/C;AAA+C;;AAI/C;;IAAA,iBAAyD;;IAAzD,sBAAyD;;IAAzD;AAAyD;;AAAzD;;IAAA,sBAAyD;;IAAzD;AAAyD;;AAIzD;;IAAA,iBAAwD;;IAAxD,sBAAwD;;IAAxD;AAAwD;;AAAxD;;IAAA,sBAAwD;;IAAxD;AAAwD;;AAIxD;;IAAA,aAAuC;;IAAvC,mBAAuC;;IAAvC;AAAuC;;AAIxC;;IAAA,aAAsC;;IAAtC,mBAAsC;;IAAtC;AAAsC;;AAIrC;;IAAA,kBAAgD;;IAAhD;AAAgD;;AAAhD;;IAAA,kBAAgD;;IAAhD;AAAgD;;AAIhD;;IAAA,oBAAuC;;IAAvC;AAAuC;;AAAvC;;IAAA,oBAAuC;;IAAvC;AAAuC;;AAIvC;;IAAA,oBAAwC;;IAAxC;AAAwC;;AAAxC;;IAAA,oBAAwC;;IAAxC;AAAwC;;AAIxC;;IAAA,WAAyE;;IAAzE,WAAyE;;IAAzE,kBAAyE;;IAAzE,sDAAyE;;IAAzE;AAAyE;;AAAzE;;IAAA,kBAAyE;;IAAzE;AAAyE;;AAIzE;;IAAA,WAA2E;;IAA3E,WAA2E;;IAA3E,kBAA2E;;IAA3E,sDAA2E;;IAA3E;AAA2E;;AAA3E;;IAAA,kBAA2E;;IAA3E;AAA2E;;AAI3E;;IAAA,iBAA8D;;IAA9D,kBAA8D;;IAA9D,kBAA8D;;IAA9D,iBAA8D;;IAA9D,kBAA8D;;IAA9D,mBAA8D;;IAA9D;AAA8D;;AAA9D;;IAAA;;QAAA,gBAA8D;;QAA9D,kBAA8D;;QAA9D;IAA8D;AAAA","sourcesContent":["\n\n.main-bg {\n    @apply dark:bg-d-background bg-l-background;\n}\n\n.secondary-bg {\n    @apply dark:bg-d-background-2 bg-l-background-2;\n}\n\n.third-bg {\n    @apply dark:bg-d-background-3 bg-l-background-3;\n}\n\n.fourth-bg {\n    @apply dark:bg-d-background-4 bg-l-background-4;\n}\n\n.main-border {\n    @apply border-[1px] dark:border-slate-700 border-gray-300;\n}\n\n.normal-border {\n    @apply border-[1px] dark:border-d-main-2 border-l-main-2;\n}\n\n.flex-center {\n    @apply flex items-center justify-center;\n}\n\n.flex-start {\n   @apply flex items-center justify-start;\n}\n\n.menu-hover {\n    @apply dark:hover:bg-slate-800 hover:bg-gray-200;\n}\n\n.text-secondary {\n    @apply dark:text-d-main-2 text-l-main-2;\n}\n\n.text-third {\n    @apply dark:text-slate-400 text-gray-600;\n}\n\n.w-line {\n    @apply bg-d-background-2 dark:bg-l-background-2 w-full h-[1px] opacity-20;\n}\n\n.mini-w-line {\n    @apply bg-d-background-2 dark:bg-l-background-2 opacity-20 h-[1px] w-[24px];\n}\n\n.page-content {\n    @apply max-w-[1367px] mx-auto mt-6 lg:mt-20 px-4 lg:px-8 pb-10;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
